import { SearchQuery } from './types'

// Sort queries based on sortColumn and sortDirection
export function sortQueries(
  queriesToSort: SearchQuery[],
  sortColumn: string | null,
  sortDirection: 'asc' | 'desc'
): SearchQuery[] {
  if (!sortColumn) return queriesToSort

  const sorted = [...queriesToSort].sort((a, b) => {
    let aValue: string | number
    let bValue: string | number
    let isString = false

    switch (sortColumn) {
      case 'name':
        aValue = a.name.toLowerCase()
        bValue = b.name.toLowerCase()
        isString = true
        break
      case 'last_scraped_at':
        aValue = a.last_scraped_at ? new Date(a.last_scraped_at).getTime() : 0
        bValue = b.last_scraped_at ? new Date(b.last_scraped_at).getTime() : 0
        break
      case 'total_jobs_found':
        aValue = a.total_jobs_found || 0
        bValue = b.total_jobs_found || 0
        break
      case 'scraped_jobs_count':
        aValue = a.scraped_jobs_count || 0
        bValue = b.scraped_jobs_count || 0
        break
      case 'relevance_verdict_summary':
        // Sort by total Fit count, then by No Fit count
        const aFit = a.relevance_verdict_summary?.fit || 0
        const bFit = b.relevance_verdict_summary?.fit || 0
        const aNoFit = a.relevance_verdict_summary?.no_fit || 0
        const bNoFit = b.relevance_verdict_summary?.no_fit || 0
        
        // First compare by Fit count
        if (aFit !== bFit) {
          aValue = aFit
          bValue = bFit
        } else {
          // If Fit counts are equal, compare by No Fit count
          aValue = aNoFit
          bValue = bNoFit
        }
        break
      default:
        return 0
    }

    if (isString) {
      const compare = aValue.localeCompare(bValue, 'en', { sensitivity: 'base', numeric: true })
      return sortDirection === 'asc' ? compare : -compare
    }
    
    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return sortDirection === 'asc' ? aValue - bValue : bValue - aValue
    }
    
    return 0
  })

  return sorted
}
